module.exports = __webpack_public_path__ + "img/img_disease3.2d40c88d.jpg";